import { Button } from "components/DesignSystem/Button/Button";
import { DateInput } from "components/DesignSystem/DateInput/DateInput";
import Modal from "components/DesignSystem/Modal/Modal";
import { YYYY_MM_DD } from "constants/date";
import dayjs from "dayjs";
import { Field, FieldProps, Form, Formik, FormikValues } from "formik";
import { opsBulkActionSchema } from "formValidations/opsBulkActionSchema";
import { useToast } from "hooks/useToast";
import { useUpdateBulkTaskMutation } from "store/apis/task";
import { BackendError } from "types/utils/error";

type Task1120BulkETDUpdateProps = {
  isOpen: boolean;
  close: () => void;
  selectedRows: string[];
  resetSelection: () => void;
};

export const Task1120BulkETDUpdateModal = ({
  isOpen,
  close,
  selectedRows,
  resetSelection,
}: Task1120BulkETDUpdateProps) => {
  const [bulkTaskUpdate, { isLoading: isUpdating }] =
    useUpdateBulkTaskMutation();

  const { promise: promiseToast } = useToast();
  const today = dayjs();
  const handleUpdate = (values: FormikValues) => {
    promiseToast(
      () =>
        bulkTaskUpdate({
          payload: {
            task_ids: selectedRows,
            estimated_delivery_time: dayjs(values.value).format(YYYY_MM_DD),
          },
        }).unwrap(),
      {
        loading: "Updating ETD...",
        success: (data) => {
          close();
          resetSelection();
          return `ETD updated for ${selectedRows.length} tasks`;
        },
        error: (error) =>
          (error as BackendError)?.data?.error?.message || "Please try again",
      }
    );
  };

  return (
    <>
      <Modal.Root open={isOpen} onOpenChange={close}>
        <Modal.Content>
          <Modal.Header>
            <Modal.Title>Update ETD</Modal.Title>
          </Modal.Header>
          <Formik
            initialValues={{ value: "" }}
            onSubmit={handleUpdate}
            enableReinitialize
            validationSchema={opsBulkActionSchema}
          >
            {({ handleSubmit, setFieldValue }) => {
              return (
                <Form onSubmit={handleSubmit} className="t-m-0">
                  <Modal.Body>
                    <Field name="value">
                      {({ field }: FieldProps) => {
                        return (
                          <DateInput
                            {...field}
                            portalId="estimated_delivery_time_portal"
                            onDateChange={(date) =>
                              setFieldValue("estimated_delivery_time", date)
                            }
                            minDate={today.toDate()}
                          />
                        );
                      }}
                    </Field>
                  </Modal.Body>

                  <Modal.FooterButtonGroup>
                    <Modal.RawClose asChild>
                      <Button type="button">Cancel</Button>
                    </Modal.RawClose>
                    <Button
                      customType="primary"
                      type="submit"
                      isLoading={isUpdating}
                    >
                      Update all ({selectedRows.length})
                    </Button>
                  </Modal.FooterButtonGroup>
                </Form>
              );
            }}
          </Formik>
        </Modal.Content>
      </Modal.Root>
    </>
  );
};
